// extracted by mini-css-extract-plugin
module.exports = {"link":"link-module--link--3eyVh","fontsLoading":"link-module--fonts-loading--2YARl"};